/*
https://www.tiny.cloud/docs/tinymce/latest/basic-setup/
https://www.tiny.cloud/docs/tinymce/latest/available-toolbar-buttons/
https://www.tiny.cloud/get-tiny/language-packages/
*/
/* global tinymce */
window.setWysiwyg = function () {
  tinymce.init({
    selector: '.js-wysiwyg',
    language: 'ja', // 言語
    height: 400, // 高さ
    plugins: 'link',
    toolbar: [
      // ツールバー(2段)
      // 戻る 進む | 太字 斜体 | 左寄せ 中央寄せ 右寄せ 均等割付 インデントを減らす インデント
      'undo redo | fontsizeinput | forecolor | bold | link unlink',
    ],

    menubar: '',

    setup: function (ed) {
      ed.on('init', function () {
        setTimeout(() => {
          // 初期フォントサイズ
          this.execCommand('fontSize', false, '13px')

          document.activeElement.blur() // 今アクティブな要素のフォーカスを解除
        }, 300)
      })
    },
  })
}
window.setWysiwyg() // エディタセットアップ
